module.exports = __webpack_public_path__ + "static/img/6en.fb0ec6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/oppo/6en.png
// module id = v/KG
// module chunks = 0